document.addEventListener('DOMContentLoaded', function () {

  let url = new URL(window.location.href);
    const variantParam = url.searchParams.get("variant");

    // Check if there is only one .product-options__value element
    const productOptions = document.querySelectorAll(".product-page-info__options .product-options__value");
    if (variantParam && productOptions.length === 1) {
     // Clear all URL parameters
      url.search = '';
      productOptions[0].classList.remove('active');

      // Replace the current URL without reloading the page
      window.history.replaceState({}, document.title, url);
      }
 
  
    
  if (window.innerWidth < 1024) {
    // Select the elements
    var languageButton = document.querySelector('.header__btn-language');
    var dropdown = document.querySelector('.header__dropdown');
    var mainContent = document.getElementById('MainContent');
    // Add click event listener to the language button
    languageButton.addEventListener('click', function () {
        // Check if the dropdown has the 'd-none' class
        if (dropdown.classList.contains('d-none')) {
            // Remove the 'd-none' class
            dropdown.classList.remove('d-none');
           mainContent.style.zIndex = '1';
        } else {
            // Add the 'd-none' class
            dropdown.classList.add('d-none');
            mainContent.style.zIndex = '2';
        }
    });

    dropdown.addEventListener('click', function () {
        // Check if the dropdown has the 'd-none' class
        if (dropdown.classList.contains('d-none')) {
            // Remove the 'd-none' class
            dropdown.classList.remove('d-none');
        } else {
            // Add the 'd-none' class
            dropdown.classList.add('d-none');
        }
    });
  }  
});

jQuery( function($) {
    $(document).ready(function() {
        $('.slider-section').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            pauseOnHover: false,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });
    });

  // Highlight specific words in product description
    const searchWords = ["OVERVIEW", "FEATURES", "SPECIFICATIONS"];
    const wrapper = "<strong>$&</strong>";

    $(".product-page-info__description span").contents().each(function () {
        if (this.nodeType === 3) { // Only process text nodes
            searchWords.forEach((word) => {
                const regex = new RegExp(`\\b${word}\\b`, "g");
                if (regex.test(this.nodeValue)) {
                    $(this).replaceWith(this.nodeValue.replace(regex, wrapper));
                }
            });
        }
    });
});

jQuery(document).ready(function () {

   var price = jQuery('.product-page-info__price').html();
   var atome = jQuery('.atome-widget').html();
   var icons = jQuery('.product-page-info__icon-with-text').html(); 
   var buttons = jQuery('.product-page-info__details-buttons').html();
  
 

     jQuery('#product-form-template--23879756185888__main').before('<div class="product-page-info__border border-top border--dashed my-25"></div><div class="product-page-info__icon-with-text product-page-info__icon-with-text-mobile product-page-info__icon-with-text--style-inline my-30">'+icons+'</div><div class="product-page-info__details-buttons product-page-info__details-buttons-mobile mb-30 mb-md-15 overflow-hidden">'+buttons
+'</div>');

    // jQuery('#product-form-installment-template--17369035767981__main').insertBefore('.product-page-info__stock-countdown');

    

 }); 


// product page video popup script //

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".feature-section .video-wrapper").forEach(function (wrapper) {
    wrapper.addEventListener("click", function () {
      const modal = document.getElementById("videoModal");
      const video = document.getElementById("youtubeVideo");

      const featureSection = wrapper.closest(".feature-section");
      const videoUrl = featureSection.getAttribute("data-video-url");

      video.src = `${videoUrl}?autoplay=1`;
      modal.style.display = "block";
    });
  });

  document.getElementById("closeModal").addEventListener("click", function () {
    const modal = document.getElementById("videoModal");
    const video = document.getElementById("youtubeVideo");
    video.src = "";
    modal.style.display = "none";
  });

  window.addEventListener("click", function (e) {
    const modal = document.getElementById("videoModal");
    if (e.target === modal) {
      document.getElementById("youtubeVideo").src = "";
      modal.style.display = "none";
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const closeButton = document.querySelector('.popup-cart__close');
  const targetElement = document.querySelector('.popup__body');

  if (closeButton && targetElement) {
    closeButton.addEventListener('click', function () {
      // Optional delay if needed
      setTimeout(() => {
        targetElement.click();
        console.log('✅ .home-section-title clicked automatically!');
      }, 100);
    });
  }
});
